import $ from 'jquery';

let $container = $('.su-menu__main-nav--search, .menu-mobile__items');
let $form = $('.su-menu__main-nav--search .search-form');

$container.find('.search--open').on('click', function (e) {
	e.preventDefault();
	$(this).addClass('active');
	$(this).next().find('.input-group-field').focus();
});

$container.find('.search--submit').on('click', function (e) {
	e.preventDefault();
	$form.submit();
});

$container.find('a.search--exit').on('click', function (e) {
	e.preventDefault();
	$container.find('.search--open').removeClass('active');
});